import React, { useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useNotify } from 'react-admin';
import {checkAndParseResponse, User} from '../dataProvider';

const cleanup = () => {
    // Remove the ?code&state from the URL
    window.history.replaceState(
        {},
        window.document.title,
        window.location.origin
    );
};

const AuthCallbackPage = () => {
    const navigate = useNavigate();
    const notify = useNotify();

    const handleOAuth = async () => {
        try {
            console.log("handleOAuth:" + window.location.href);
            const hash = window.location.hash;
            const queryString = hash.split('?')[1];
            const params = new URLSearchParams(queryString);
            const code = params.get('code');
            const state = params.get('state');
            if (!code) {
                console.log("code not found.");
                notify('No code found in URL', { type: 'warning' });
                navigate('/login');
                return;
            }
            if (!state) {
                console.log("state not found");
                notify('No state found in URL', { type: 'warning' });
                navigate('/login');
                return;
            }

            console.log("Starting oauth callback");
            const response = await fetch(`/api/v1/auth/callback?code=${code}&state=${state}`, {
                method: 'GET',
                credentials: 'include',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                mode: 'cors',
            });
            console.log(`Oauth callback response: ${JSON.stringify(response, null, 2)}`);
            cleanup();



            if (!response.ok) {
                let errorMessage = `HTTP error! status: ${response.status}`;
                if (response.status === 400) {
                    errorMessage = 'Invalid request';
                } else if (response.status === 422) {
                    errorMessage = 'Invalid Credentials';
                } else if (response.status === 500) {
                    errorMessage = 'Server error';
                }
                throw new Error(errorMessage);
            }



            interface AuthenticateResponse {
                id: string;
                name: string;
                avatar: string;
                displayName: string;
            }

            const result: AuthenticateResponse = await checkAndParseResponse(response);
            const { id, name, avatar } = result;

            console.log(`OAuth callback response: ${JSON.stringify(result)}`);

            localStorage.setItem('userId', id);
            localStorage.setItem('userName', name);
            localStorage.setItem('avatar', avatar);
            localStorage.setItem('displayName', result.displayName);

            // Navigate to the home page
            navigate('/');
        } catch (error) {
            console.error('Error calling oauth callback:', error);
            if (error instanceof Error) {
                notify(error.message, { type: 'error' });
            } else {
                notify('An unknown error occurred', { type: 'error' });
            }
            navigate('/login');
        }
    };
    useEffect(() => {
        handleOAuth();
    }, [navigate]);

    return <CircularProgress size={25} thickness={2} />;
};

export default AuthCallbackPage;
